import request from '../request';

export const getModules = () => request({
    url: '/module',
    method: 'GET',
});